import React from "react";
import style from "../../style.module.css";

type LayoutProps = {
  children: React.ReactNode;
};

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <>
      <div className={style["layout"]}>
        {children}
      </div>
    </>
  );
};

export default Layout;
